/*=========================================================================================
  File Name: moduleReservationPaymentStatus.js
  Description: ReservationPaymentStatus Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './modulePaymentStatusState.js'
import mutations from './modulePaymentStatusMutations.js'
import actions from './modulePaymentStatusActions.js'
import getters from './modulePaymentStatusGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
